import ChildJobs from './ChildJobs.yaml?component';
import Job from './Job.yaml?component';
import JobFiles from './JobFiles.yaml?component';
import JobHandlerControl from './JobHandlerControl.yaml?component';
import JobHeader from './JobHeader.yaml?component';
import JobProgress from './JobProgress.yaml?component';
import JobRuns from './JobRuns.yaml?component';
import JobRunView from './JobRunView.yaml?component';
import JobView from './JobView.yaml?component';
import UcJobNameBadge from './UcJobNameBadge.yaml?component';

export {
  ChildJobs,
  Job,
  JobFiles,
  JobHandlerControl,
  JobHeader,
  JobProgress,
  JobRuns,
  JobRunView,
  JobView,
  UcJobNameBadge,
};
